import { useTranslation } from "react-i18next";

import { formatToLocalizedDateTime } from "libs/design-system/src/utils/dateFormats";

import { useLangStore } from "@app/dashboard/store/lang";
import { DetailsBox } from "../../components/DetailsBox";
import { NO_VALUE } from "../../../utils";
import styles from "./case-details.module.scss";


export const CaseDetails = ({
  disputeId,
  dueDate,
  reason
}: {
  disputeId?: string | number,
  dueDate?: string,
  reason?: string,
}) => {
  const { lang } = useLangStore();
  const { t } = useTranslation();

  const ITEMS_LIST = [
    {
      label: t('innerLayout.disputesPage.disputeDetails.detailsBoxes.caseDetails.fields.disputeId'),
      value: { text: <span className={styles["case-details__value--dimmed"]}>{disputeId}</span> } as any,
    },
    {
      label: t('innerLayout.disputesPage.disputeDetails.detailsBoxes.caseDetails.fields.dueDate'),
      value: {
        text: <span className={styles["case-details__value--dimmed"]}>
          {formatToLocalizedDateTime(dueDate as string, lang)}
        </span>
      } as any,
    },
    {
      label: t('innerLayout.disputesPage.disputeDetails.detailsBoxes.caseDetails.fields.reason'),
      value: {
        text: <span
          data-case-details-empty={!reason}
          className={styles["case-details__value--danger"]}>
          {reason || NO_VALUE}
        </span>
      } as any,
    },
  ];


  return (
    <div className={styles["case-details"]}>
      <DetailsBox
        label={t('innerLayout.disputesPage.disputeDetails.detailsBoxes.caseDetails.title')}
        itemsList={ITEMS_LIST}
      />
    </div>
  )
}
